/* Skyla Rose Fitting Room (Skylaroseco site only) — default shoes on built models, adults only.
   AI-built models are created barefoot, so the try-on was inventing its own shoes.
   After a look is made on a model the shopper built, we add our own styling shoes:
   - Resort pieces (linens, maxi and linen dresses): nude kitten heels (women's models)
   - Loungewear (Cosy Club, Summer Club, Love & Leisure, Retro): white trainers
   Shopper photos and selfies keep their own shoes. Kids: no shoes added.
   Not used on the SÁRO launch theme, which has its own styling rules (saro-tryon-pair.js).
   Uses the try-on service's /style step; if it fails the look is shown without the change. */
(function(){
  function recall(k){ try { return sessionStorage.getItem(k); } catch(e){ return null; } }
  function store(k, v){ try { sessionStorage.setItem(k, v); } catch(e){} }
  function asDataUrl(out){ return (out.indexOf('data:') === 0 || out.indexOf('http') === 0) ? out : 'data:image/jpeg;base64,' + out; }

  function init(root){
    if (!root || !root.dataset.api || root.dataset.shoesReady || root.dataset.kids === 'true') return;
    root.dataset.shoesReady = '1';
    var api = root.dataset.api;
    var handle = (root.dataset.product || '').toLowerCase();
    var resort = /linen|maxi|solenne|coastline|paradiso|euro-summer|dress/.test(handle);

    // Remember whether the current person is a model the shopper built (and which), or their own photo
    root.addEventListener('click', function(e){
      var card = e.target.closest('.saro-tryon__card');
      if (card) store('saro_person_kind', card.dataset.mode === 'model' ? 'model' : 'photo');
      if (e.target.closest('.saro-tryon__bgo')) {
        var g = root.querySelector('[data-group="gender"] [aria-pressed="true"]');
        store('saro_person_gender', g ? g.dataset.value : 'woman');
        store('saro_person_kind', 'model');
      }
    }, true);

    function poll(id){
      return new Promise(function(resolve, reject){
        var tries = 0;
        (function tick(){
          if (++tries > 60) return reject();
          fetch(api + '/status/' + id).then(function(r){ return r.json(); }).then(function(st){
            if (st.status === 'completed' && st.output) resolve(st.output);
            else if (st.status === 'failed') reject(st.error);
            else setTimeout(tick, 1500);
          }).catch(function(){ setTimeout(tick, 2500); });
        })();
      });
    }
    function busy(on){
      var v = root.querySelector('.saro-tryon__vload'); if (!v) return;
      var t = root.querySelector('.saro-tryon__vload-title'), sub = root.querySelector('.saro-tryon__vload-sub');
      var track = root.querySelector('.saro-tryon__track'), pct = root.querySelector('.saro-tryon__vload-pct');
      v.hidden = !on; if (track) track.hidden = on; if (pct) pct.hidden = on;
      if (on) { t.textContent = 'Styling your look'; sub.textContent = 'Just a few more seconds.'; }
      else { t.textContent = 'Bringing your look to life'; }
    }

    var run = 0;
    root.addEventListener('saro:look', function(e){
      if (e.detail && (e.detail.styled || e.detail.paired)) return;
      if (recall('saro_person_kind') !== 'model') return;
      var man = recall('saro_person_gender') === 'man';
      var props;
      if (resort) { if (man) return; props = { heels: 'neutral' }; }
      else props = { trainers: 'white' };
      var img = root.saroGetLook && root.saroGetLook();
      if (!img) return;
      var mine = ++run;
      busy(true);
      fetch(api + '/style', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ image: img, props: props, look: { kids: false }, consent: { v: 'v1.1', who: 'me', blur: false, mode: 'model', session: recall('saro_session'), product: root.dataset.product } }) })
        .then(function(r){ return r.json(); })
        .then(function(d){ if (!d.id) throw d.error; return poll(d.id); })
        .then(function(out){ if (mine === run && root.saroGetLook() === img) root.saroSetLook(asDataUrl(out)); })
        .catch(function(){})
        .then(function(){ if (mine === run) busy(false); });
    });
  }

  function scan(){ document.querySelectorAll('.saro-tryon[data-api]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  setTimeout(scan, 1500);
})();
